import './view-cart.scss';
import NotificationRequired from "../../../../components/UI/Notification/NotificationRequired";
import ButtonKMQ from "../../../../components/UI/Button/ButtonKMQ";
import {ButtonTypes} from "../../../../constants/ui/types/ButtonTypes";
import {useNavigate, useParams} from "react-router-dom";
import {useContext, useEffect, useState} from "react";
import {UserContext} from "../../../../hooks/Context/UserContext";
import {PortfolioContext} from "../../../../hooks/Context/PortfolioContext";
import Loading from "../../../../components/UI/Loading/Loading";
import TrashIcon from '../../../../assets/icons/UI/icons/delete.svg';
import {useAddToCart} from "../../../../api/payment/useAddToCart";
import AlertModal from '../../../../components/UI/Modals/AlertModal/AlertModal';
import {WarningCircle} from '@phosphor-icons/react';
import {useMutateStripeSession} from "../../../../api/payment/useMutateStripeSession";
import {useQueryCart} from "../../../../api/payment/useQueryCart";
import {ICartItem} from "../PaymentComponents/Summary";

const ViewCart = () => {
  const [user] = useContext(UserContext);
  const navigate = useNavigate();
  const [portfolio, setPortfolio] = useContext(PortfolioContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    mutate: mutateStripeSession,
    isSuccess,
    isPending: isPendingStripe,
    data
  } = useMutateStripeSession();

  const {data: cartData, refetch: refetchCart, isPending} = useQueryCart({
    portfolio_id: portfolio?.id ? portfolio.id : localStorage.getItem('portfolio_id'),
    payment_intent_id: data?.payment_intent_id
  });

  const {mutate: addToCart, isSuccess: removeFromCartSuccess} = useAddToCart({
    userIsSoft: user.isSoft
  });

  const removeCourse = (course_id: string) => {
    addToCart({
      course_recommendation_id: course_id,
      select_for_payment: false
    })
  }
  const handleProceedCheckout = () => {
    setIsModalOpen(false);
    navigate(`/cpl-applicant/payment/${data.payment_intent_id ?? 'session-id'}`);
  };

  useEffect(() => {
    let portfolio_id = portfolio?.id ? portfolio.id : localStorage.getItem('portfolio_id');
    if (portfolio_id && !data) {
      mutateStripeSession({
        portfolio_id: portfolio_id
      })
    }
  }, [portfolio])

  useEffect(() => {
    if (isSuccess && data) {
      setPortfolio({
        ...portfolio,
        clientSecret: data.clientSecret,
        banner_text: data.banner_text,
      })
    }
  }, [isSuccess, data, navigate])

  useEffect(() => {
    if (removeFromCartSuccess) {
      mutateStripeSession({
        portfolio_id: portfolio?.id ? portfolio.id : localStorage.getItem('portfolio_id') ?? ''
      })
    }
  }, [removeFromCartSuccess])

  useEffect(() => {
    window.scroll(0, 0);
  }, [])

  return <div className={'view-cart'}>
    <Loading loading={isPending || isPendingStripe}/>
    <div className={'view-cart-title'}>
      My Cart
    </div>
    <div className={'view-cart-subtitle'}>
      Courses
    </div>
    <table className={'view-cart-courses'}>
      {
        (cartData && cartData?.items)
          ? cartData?.items.map((item: ICartItem, index: number) =>
            <tr key={index}>
              <td className={'view-cart-courses-index'}>
                {index + 1}.
              </td>
              <td className={'view-cart-courses-name'}>
                <div className={'view-cart-courses-name-course'}>
                  {item.name}
                </div>
                <div className={'view-cart-courses-name-program'}>
                  {item.additional_fields?.program_when_added_cart?.name ?? ""}
                </div>
              </td>
              <td className={'view-cart-courses-price'}>
                CAD${item.price.toFixed(2)}
              </td>
              <td>
                <img
                  src={TrashIcon}
                  alt={'remove-course'}
                  className={'view-cart-courses-remove'}
                  onClick={() => removeCourse(item?.additional_fields.course_recommendation_id)}
                />
              </td>
            </tr>
          )
          : null
      }
    </table>
    <NotificationRequired>
      Note: Your payment for these courses covers the review process service and does not constitute the purchase of
      credits from the institution.
    </NotificationRequired>
    <div className={'view-cart-footer'}>
      <ButtonKMQ onClick={() => navigate('/cpl-applicant/my-programs')}>
        Add more courses
      </ButtonKMQ>
      <ButtonKMQ onClick={() => setIsModalOpen(true)} type={ButtonTypes.Tertiary}>
        Checkout
      </ButtonKMQ>
    </div>

    <AlertModal
      open={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      text="Your payment for these courses covers the review process service and does not constitute the purchase of credits from the institution."
      proceedText="Yes, I understand"
      onProceed={handleProceedCheckout}
      title="Note: You're not buying credits!"
      closeText="No, what!"
      icon={<WarningCircle size={56} color="#212121"/>}
    />
  </div>
}

export default ViewCart;